import { useState, useEffect } from "react";
import { useAppContext } from "src/api/AppContext";
import { RolePermissionType, UserRole } from "src/generated/graphql";
import { EMPLOYEE_ROLE_OBJ } from "src/utils/constants";

const useWritePermission = (roleType: EMPLOYEE_ROLE_OBJ) => {
  const { currentEmployee, currentUser } = useAppContext();
  const [isAllowed, setIsAllowed] = useState<boolean>(true);

  useEffect(() => {
    if (currentEmployee?.id) {
      const hasPermission =
        currentEmployee?.role?.[roleType] === RolePermissionType.Write;
      setIsAllowed(hasPermission);
    } else if (currentUser?.role === UserRole.Admin) {
      setIsAllowed(true);
    } else {
      setIsAllowed(false);
    }
  }, [currentEmployee, roleType]);

  return isAllowed;
};

export default useWritePermission;
